import React, { useState } from 'react'
import "./Login.css"
import { RegisterUser } from '../../Services/Operations/ProductAPI'
import { toast } from 'sonner'
import { useNavigate } from 'react-router-dom'

/* ── Inline SVG icons ── */
const IconUser = () => (
  <svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
)
const IconMail = () => (
  <svg viewBox="0 0 24 24"><rect x="2" y="4" width="20" height="16" rx="3"/><path d="m2 7 10 7 10-7"/></svg>
)
const IconPhone = () => (
  <svg viewBox="0 0 24 24"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/></svg>
)
const IconCalendar = () => (
  <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="3"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
)
const IconLock = () => (
  <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="3"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><circle cx="12" cy="16" r="1" fill="currentColor"/></svg>
)
const IconShield = () => (
  <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>
)
const IconArrow = () => (
  <svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
)
const IconBrand = () => (
  <svg viewBox="0 0 24 24"><path d="M12 2 2 7l10 5 10-5-10-5Z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
)
const CornerSeal = () => (
  <svg className="corner-seal" viewBox="0 0 36 36" fill="none">
    <circle cx="18" cy="18" r="16" stroke="#C9962A" strokeWidth="1"/>
    <circle cx="18" cy="18" r="11" stroke="#C9962A" strokeWidth="0.5"/>
    <path d="M18 6 L19.2 15 L28 15 L21.4 20.5 L23.8 29 L18 24 L12.2 29 L14.6 20.5 L8 15 L16.8 15 Z"
      fill="#C9962A" opacity="0.6"/>
  </svg>
)

const Registration = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [full_name, setFullName] = useState("")
  const [phone, setphone] = useState("")
  const [birth_date, setBirthDate] = useState("")
  const [password_confirmation, setpasswordConformation] = useState("")
  const [state, setState] = useState(0)

  const navigate = useNavigate()

  const handleSignup = async () => {
    try {
      if (password !== password_confirmation) {
        toast.warning("PASSOWRD DOES NOT MATCH WITH CONFORM PASSWORD")
      }
      setState(1)
      let data = { email, password, full_name, phone, birth_date, password_confirmation }
      console.log(data)
      const res = await RegisterUser(data)
      console.log(res)
      if (res.status === 201) {
        toast.success("Member registered successfully")
        setState(0)
        navigate("/login")
        return
      }
      const serverErrors = res.data.errors
      const firstKey = Object.keys(serverErrors)[0]
      const message = serverErrors[firstKey][0]
      toast.info(message)
    } catch (error) {
      console.log(error)
      toast.error("Failed to register")
    } finally {
      setState(0)
    }
  }

  return (
    <div className='body'>
      <div className='form' style={{ maxWidth: '480px', padding: '44px 44px 40px' }}>

        <CornerSeal />

        {/* Brand */}
        <div className="login-brand">
          <div className="login-icon-wrap">
            <IconBrand />
          </div>
          <h1 className="login-title">Create Account</h1>
          <p className="login-subtitle">Join us today</p>
        </div>

        {/* Two-column grid for fields */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '26px' }}>

          {/* Full Name — full width */}
          <div className="field-wrap" style={{ gridColumn: '1 / -1' }}>
            <label className="field-label">Full Name</label>
            <div className="input-row">
             
              <input className="field-input" placeholder="Your full name" type="text"
                value={full_name} onChange={(e) => setFullName(e.target.value)} />
            </div>
          </div>

          {/* Email — full width */}
          <div className="field-wrap" style={{ gridColumn: '1 / -1' }}>
            <label className="field-label">Email Address</label>
            <div className="input-row">
             
              <input className="field-input" placeholder="you@example.com" type="email"
                value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
          </div>

          {/* Phone */}
          <div className="field-wrap">
            <label className="field-label">Phone</label>
            <div className="input-row">
             
              <input className="field-input" placeholder="+91 00000 00000" type="number"
                value={phone} onChange={(e) => setphone(e.target.value)} />
            </div>
          </div>

          {/* Birth Date */}
          <div className="field-wrap">
            <label className="field-label">Birth Date</label>
            <div className="input-row">
             
              <input className="field-input" type="date"
                value={birth_date} onChange={(e) => setBirthDate(e.target.value)} />
            </div>
          </div>

          {/* Password */}
          <div className="field-wrap">
            <label className="field-label">Password</label>
            <div className="input-row">
            
              <input className="field-input" placeholder="Create password" type="password"
                value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
          </div>

          {/* Confirm Password */}
          <div className="field-wrap">
            <label className="field-label">Confirm Password</label>
            <div className="input-row">
             
              <input className="field-input" placeholder="Repeat password" type="password"
                value={password_confirmation} onChange={(e) => setpasswordConformation(e.target.value)} />
            </div>
          </div>

        </div>

        {/* Submit button */}
        <div className="btn-wrap">
          <button className="login-btn" onClick={() => handleSignup()} disabled={!!state}>
            {state ? (
              <span className="btn-loading">
                <span className="spinner" />
                Creating account…
              </span>
            ) : (
              <>
                Create Account
                <IconArrow />
              </>
            )}
          </button>
        </div>

        {/* Divider */}
        <div className="divider">
          <span className="divider-line" />
          <span className="divider-text">Already a member?</span>
          <span className="divider-line" />
        </div>

        {/* Footer */}
        <p className="login-footer">
          Have an account?{' '}
          <span onClick={() => navigate("/login")}>Sign In</span>
        </p>

      </div>
    </div>
  )
}

export default Registration
